var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaking(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M331.89111,452.70117l-89.26465-48.06543,12.89893-25.79785a27.32593,27.32593,0,0,0-37.71143-36.1084L157.92676,376H56v16h96v88H56v16H320.97461a23.0256,23.0256,0,0,0,10.9165-43.29883ZM320.97461,480H168V388.707l57.58447-31.99121a11.32585,11.32585,0,0,1,15.63037,14.96582l-16.37011,32.74024A8.0004,8.0004,0,0,0,228.207,415.044l96.09766,51.74414A7.02571,7.02571,0,0,1,320.97461,480Z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.31348,120l3.71582-3.71582A84.69311,84.69311,0,0,0,384,56a8.00008,8.00008,0,0,0-8-8H356.94434l-7.856-15.71191A29.30516,29.30516,0,0,0,322.73291,16a29.60745,29.60745,0,0,0-23.57275,11.78711L291.49951,38.001A9.44476,9.44476,0,0,1,278.709,40.19141L268.4375,33.34375a8.00736,8.00736,0,0,0-6.9668-.93359l-10.66357,3.55371A27.47292,27.47292,0,0,0,232,62.05859a89.26739,89.26739,0,0,0,20.93262,57.69532l-61.33448,61.334A161.44906,161.44906,0,0,0,144,296a159.22761,159.22761,0,0,0,11.21191,58.94922l14.87305-5.89844A143.29628,143.29628,0,0,1,160,296a145.55079,145.55079,0,0,1,42.91162-103.59766L267.314,128H284.686l-.97071.9707A39.74137,39.74137,0,0,0,272,157.25488V176h16V157.25488a23.84541,23.84541,0,0,1,7.0293-16.9707l8.97082-8.97046,8.97009,8.96948A23.84779,23.84779,0,0,1,320,157.25488V176h16V157.25488a39.74371,39.74371,0,0,0-11.71582-28.28515L323.31445,128H340.686l64.40234,64.40234A145.55079,145.55079,0,0,1,448,296a143.80562,143.80562,0,0,1-98.52441,136.6748l5.04882,15.18165A159.78137,159.78137,0,0,0,464,296a161.44906,161.44906,0,0,0-47.59814-114.91211Zm-14.62708-8H267.42529A73.40315,73.40315,0,0,1,248,62.05859a11.491,11.491,0,0,1,7.8667-10.915l6.95117-2.31738,7.01611,4.67774a25.44771,25.44771,0,0,0,34.46534-5.90332L311.96,37.38672A13.53145,13.53145,0,0,1,322.73291,32a13.39318,13.39318,0,0,1,12.04492,7.44434l10.0669,20.13378A7.99967,7.99967,0,0,0,352,64h15.5459a68.726,68.726,0,0,1-19.83057,40.9707Z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,296a104,104,0,1,0-202.08008,34.666l15.08545-5.332a87.90917,87.90917,0,1,1,53.66113,53.66016l-5.333,15.08594A104.06739,104.06739,0,0,0,408,296Z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11572,269.26074,275.88428,255.54l-16,9.59961A8.00091,8.00091,0,0,0,256,272v48a8.00153,8.00153,0,0,0,3.88379,6.86035l40,24a8.00333,8.00333,0,0,0,8.23242,0l40-24A8.00153,8.00153,0,0,0,352,320l-.00049-48.001a8.00093,8.00093,0,0,0-3.88428-6.86035l-39.99951-23.999a8.00157,8.00157,0,0,0-8.23144,0l-13.3335,8,8.23145,13.7207L304,257.3291l31.99951,19.19922L336,315.4707l-32,19.2002-32-19.2002V276.5293Z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.3e8248cb0ee0717735c8777972fd88d8.svg";
export { ForwardRef as ReactComponent };